var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "allBox"
    },
    [
      _c(
        "div",
        { staticClass: "allBoxTitle" },
        [
          _c("h3", { staticClass: "allTitle" }, [
            _vm._v(_vm._s(_vm.$t("HotItems")))
          ]),
          _vm._v(" "),
          _c("router-link", { attrs: { to: { path: "/market" } } }, [
            _vm._v(_vm._s(_vm.$t("ViewMore")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { ref: "ball", staticClass: "ball" }),
      _vm._v(" "),
      _vm.list != null
        ? _c(
            "ul",
            { staticClass: "hot products" },
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: {
                    outStock: item.Status == 2 && item.Presale != 1,
                    sold:
                      item.Status != 2 &&
                      item.QuantitySold <= 0 &&
                      item.Presale != 1,
                    presale: item.Presale == 1
                  }
                },
                [
                  item.Status == 2
                    ? _c("i", { class: "lang-" + _vm.$i18n.locale })
                    : _vm._e(),
                  _vm._v(" "),
                  item.Presale == 1
                    ? _c("i", { class: "lang-" + _vm.$i18n.locale })
                    : _vm._e(),
                  _vm._v(" "),
                  item.QuantitySold <= 0
                    ? _c("div", { staticClass: "outOfStock" }, [
                        _vm._v(_vm._s(_vm.$t("OutofStock")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userInfo != null &&
                  item.QuantitySold > 0 &&
                  item.Presale != 1
                    ? _c(
                        "el-button",
                        {
                          staticClass: "addCart",
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.toCart($event, item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("AddtoCart")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: { path: "/market/item/" + item._id + "?type=1" }
                      }
                    },
                    [
                      _c("div", { staticClass: "imgBox" }, [
                        _c("img", {
                          attrs: { src: item.TitImg + "?imageView2/2/w/238" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "line_txt3 productsText" }, [
                        _vm._v(_vm._s(item.Title) + "\n        ")
                      ]),
                      _vm._v(" "),
                      item.QuantitySold && item.QuantitySold > 0
                        ? _c("div", { staticClass: "productsPrice" }, [
                            _vm._v(_vm._s(item.Price.toLocaleString()))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.HideType != 1 &&
                      item.QuantitySold && item.QuantitySold <= 0
                        ? _c("div", { staticClass: "productsPrice" }, [
                            _vm._v(_vm._s(item.Price.toLocaleString()))
                          ])
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fd2b385", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fd2b385","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/hotproducts.vue
// module id = null
// module chunks = 